import { useEffect, useRef } from 'react';
import { useModalState } from '../ModalsProvider';

var useModalOpen = function useModalOpen(_a) {
  var id = _a.id,
      open = _a.open,
      onClose = _a.onClose;
  var prevOpenRef = useRef(open);

  var _b = useModalState(id),
      openGlobal = _b.open,
      onChangeOpen = _b.onChangeOpen;

  var prevOpenGlobalRef = useRef(openGlobal);
  useEffect(function () {
    if (open !== prevOpenRef.current) {
      if (open !== openGlobal) {
        onChangeOpen === null || onChangeOpen === void 0 ? void 0 : onChangeOpen(open);
      }

      prevOpenRef.current = open;
    }
  }, [open, openGlobal, onChangeOpen]);
  useEffect(function () {
    if (openGlobal !== prevOpenGlobalRef.current) {
      if (openGlobal === false && open) {
        onClose === null || onClose === void 0 ? void 0 : onClose();
      }

      prevOpenGlobalRef.current = openGlobal;
    }
  }, [openGlobal, open, onClose]);
  return openGlobal !== null && openGlobal !== void 0 ? openGlobal : open;
};

export default useModalOpen;